// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3pFbv","errorLogs":"styles_errorLogs__31ai1"};